export const pricing = {
  breadcrumb: "Precios",
  title: "Tarifs simples et flexibles",
  subtitle: "Una comisión única del 5%, pagada por quien tú quieras.",
  whoPays: {
    title: "¿Quién paga los gastos?",
    traveler: {
      label: "Opción 1: El viajero paga (Recomendado)",
      description:
        "Recibes el 100% de tu precio. El viajero añade el 5% de gastos de servicio.",
      badge: "Por defecto",
    },
    host: {
      label: "Opción 2: El anfitrión paga (Pro)",
      description:
        "Tú pagas el 5%. Precio mostrado más bajo para el viajero, ideal para empresas.",
      badge: "Opción Pro",
    },
  },
  guarantee: "Transparencia total garantizada",
  perYear: "/año",
  choose: "Elegir",
  popular: "El más popular",
  plans: {
    traveler: {
      name: "Viajero",
      description: "Para explorar el mundo a menor coste",
      price: "5%",
      period: "de comisión",
      features: [
        "Acceso a todos los alojamientos",
        "Gastos de servicio reducidos (5%)",
        "Seguro incluido",
        "Soporte 7/7",
      ],
    },
    host: {
      name: "Anfitrión",
      description: "Para alquilar sin gastos e intercambiar",
      price: "0%",
      period: "de comisión",
      features: [
        "0% de comisión sobre tus ingresos",
        "Acceso a intercambios gratuitos entre anfitriones",
        'Insignia "Precio Justo" disponible',
        "Mayor visibilidad",
        "Soporte prioritario",
      ],
    },
  },
  fairPrice: {
    title: "Programa Precio Justo",
    description: "Juega el juego, gana más.",
    benefit1: 'Insignia "Precio Justo" visible',
    benefit2: "Prioridad en los resultados",
    benefit3: "Bono de puntos de intercambio",
    condition:
      "Propón una tarifa al menos un 10% más barata que en otras plataformas.",
  },
  taxAdvantage: {
    title: "Ventaja Fiscal & Pro",
    text: "Los gastos del 5% pueden ser deducibles si eres una empresa. El modelo 0% simplifica la contabilidad de los particulares. Consulta a tu contable.",
  },
  hostExchange: {
    title: "Sistema de Intercambio Anfitrión",
    description: "Intercambia tus noches ganadas por estancias gratuitas.",
    free: "Gratis (0€)",
    community: "Reservado a miembros verificados",
  },
  comparison: {
    title: "¿Por qué es mejor?",
    subtitle: "Compara y ve la diferencia",
    features: "Gastos",
    airbnb: "Airbnb / Booking",
    traveltrok: "DONKEY TRAVEL",
    hostFees: "Gastos Anfitrión",
    travelerFees: "Gastos Viajero",
    exchange: "Intercambio Gratuito",
  },
  testimonials: {
    title: "Lo que dicen nuestros miembros",
    subtitle: "Únete a una comunidad que cambia las reglas",
    badge: "Testimonios",
    exchanges: "intercambios",
    saved: "ahorrados",
    verifiedMembers: "+15 000 miembros",
    completedExchanges: "+50 000 viajes",
    totalSaved: "0% de comisión",
  },
  faq: {
    title: "Preguntas frecuentes",
    subtitle: "Todo lo que necesitas saber sobre nuestras tarifas",
    q1: {
      question: "¿Puedo cambiar de plan en cualquier momento?",
      answer:
        "Sí, puedes pasar a un plan superior en cualquier momento. La diferencia se calculará a prorrata de tu suscripción actual.",
    },
    q2: {
      question: "¿Hay gastos adicionales?",
      answer:
        "No, ningún gasto oculto. El precio mostrado es el precio final que pagas por año. Los intercambios son luego totalmente gratuitos.",
    },
    q3: {
      question: "¿Qué pasa si no estoy satisfecho?",
      answer:
        "Ofrecemos una garantía de satisfacción o reembolso de 30 días. Si no estás satisfecho, te reembolsamos íntegramente.",
    },
    q4: {
      question: "¿Cómo funciona la facturación?",
      answer:
        "Se te factura anualmente. Puedes pagar con tarjeta bancaria o transferencia. La facturación es automática y recibes una factura por correo electrónico.",
    },
    q5: {
      question: "¿Puedo cancelar mi suscripción?",
      answer:
        "Sí, puedes cancelar en cualquier momento. Tu suscripción permanecerá activa hasta el final del periodo pagado.",
    },
  },
  cta: {
    title: "¿Listo para comenzar la aventura?",
    subtitle: "Únete a miles de propietarios que viajan gratis",
    createAccount: "Crear mi cuenta",
    exploreDestinations: "Explorar los destinos",
  },
  signup: {
    title: "Crear tu cuenta",
    subtitle: "Únete a nuestra comunidad de propietarios",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    phone: "Teléfono",
    country: "País",
    selectCountry: "Selecciona tu país",
    plan: "Plan",
    selectPlan: "Selecciona tu plan",
    propertyType: "Tipo de alojamiento",
    selectPropertyType: "Selecciona el tipo de alojamiento",
    terms: "Acepto las condiciones de uso y la política de privacidad",
    submit: "Crear mi cuenta",
    success: "¡Cuenta creada con éxito!",
    error: "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
    securityNote: "Tus datos están seguros y nunca serán compartidos",
    house: "Casa",
    apartment: "Apartamento",
    villa: "Villa",
    loft: "Loft",
    other: "Otro",
  },
  signupSection: {
    title: "Únete a DONKEY TRAVEL hoy",
    subtitle:
      "Crea tu cuenta en unos minutos y comienza a intercambiar tu alojamiento con propietarios de todo el mundo.",
    verifiedMembers: "Miembros verificados",
    verifiedMembersDesc:
      "Todos nuestros miembros son propietarios de Airbnb verificados para intercambios con total confianza.",
    guaranteedSavings: "Ahorros garantizados",
    guaranteedSavingsDesc:
      "Nuestros miembros ahorran de media 3 500€ al año en sus gastos de alojamiento.",
    globalNetwork: "Red mundial",
    globalNetworkDesc:
      "Accede a más de 15 000 alojamientos en 85 países de todo el mundo.",
    responsiveSupport: "Soporte reactivo",
    responsiveSupportDesc:
      "Nuestro equipo está disponible 7/7 para acompañarte en tus intercambios.",
  },
  testimonialItems: {
    sophie:
      "Gracias a DONKEY TRAVEL, he visitado Barcelona, Roma y Ámsterdam sin pagar alojamiento. La comunidad es reactiva y las discusiones de intercambio son sencillas.",
    thomas:
      "Me uní a la oferta de lanzamiento 2026: -50% el primer año. El precio está garantizado de por vida para los primeros 1000, e intercambio por toda Europa.",
    marie:
      "Por fin hice mi primer intercambio en Europa, y todo fue fluido desde el primer mensaje hasta la llegada. La verificación de perfiles ayuda mucho.",
    pierre:
      "Para nuestros alojamientos, el panel de control nos ahorra tiempo: anuncios, mensajes y disponibilidades son claros y fáciles de gestionar.",
  },
};
